export default {
  TypeOfFixedAsset: 'TypeOfFixedAsset',
  FixedAsset: 'FixedAsset',
  InventoryCategory1: 'InventoryCategory1',
  InventoryItem: 'InventoryItem',
  InventoryItem1: 'InventoryItem1',
  AccountObject: 'AccountObject',
  AccountingObject: 'AccountingObject',
  AccountingObjectList: 'AccountingObjectList',
  Employee: 'Employee',
  BuPlanWithDraw: 'BuPlanWithDraw',
  SalaryScale: 'SalaryScale',
  PAOption: 'PAOption',
  Department: 'Department',
  DepartmentDetail: 'Department',
  EmployeeType: 'EmployeeType',
  PayrollItem: 'PayrollItem',
  BudgetSource: 'BudgetSource',
  BudgetChapter: 'BudgetChapter',
  BudgetProvide: 'BudgetProvide',
  BudgetKindItem: 'BudgetKindItem',
  BudgetItem: 'BudgetItem',
  BuPlanWithDrawDetail: 'BuPlanWithDrawDetail',
  BankInfo: 'BankInfo',
  Project: 'Project',
  Activity: 'Activity',
  ActivityCategory: 'ActivityCategory',
  Branch: 'Branch',
  Statistic: 'Statistic',

  // Dự toán ngân sách -> Chuyển khoản kho bạc
  BUTransfer: 'BUTransfer',
  BUTransferDetail: 'BUTransferDetail',
  BUTransferDetailParallel: 'BUTransferDetailParallel',

  PAEmployeeSalaryDetail: 'PAEmployeeSalaryDetail',
  Account: 'Account',
  AccountCategory: 'AccountCategory',
  BranchType: 'BranchType',
  Currency: 'Currency',

  // Chi tiền gửi
  // nvthinh 24.1.2024: Cập nhật theo key enum phía Back-end
  BAWithDraw: 'BAWithdraw',

  // Chuyển tiền nội bộ
  // nvthinh 25.1.2024: Cập nhật theo key enum phía Back-end
  BAInternalTransfer: 'BAInternalTransfer',

  BAWithdrawDetail: 'BAWithdrawDetail',
  BAWithdrawDetailParallel: 'BAWithdrawDetailParallel',
  InventoryCategory: 'InventoryCategory',
  EquipmentInventoryItem: 'EquipmentInventoryItem',
  Stock: 'Stock',

  // danh mục khoản chi xã
  LocalBudgetItem: 'LocalBudgetItem',
  LocalBudgetItemDetail: 'LocalBudgetItemDetail',

  // Dự toán ngân sách -> Lập dự toán thu
  BUPlanReceipt: 'BUPlanReceipt',
  BUPlanReceiptDetail: 'BUPlanReceiptDetail',

  // Dự toán ngân sách -> Lập dự toán chi
  BUPlanExpense: 'BUPlanExpense',
  BUPlanExpenseDetail: 'BUPlanExpenseDetail',

  BudgetItemDetail1: 'BudgetItemDetail',

  // Dự toán ngân sách -> Nhận dự toán
  // nvthinh 24.1.2024: Cập nhật theo key enum phía Back-end
  BUReceiveBudgetPlan: 'BuReceipt',

  BUReceiveDetail: 'BUPlanReceiptDetail',
  Hamlet: 'Hamlet',
  Fund: 'Fund',
  TypeOfFundBank: 'TypeOfFundBank',
  BankInfoCategory: 'BankInfoCategory',
  BudgetGroupItem: 'BudgetGroupItem',
  BudgetGroupItem1: 'BudgetGroupItem1',

  // Phiếu thu
  // nvthinh 24.1.2024: Cập nhật theo key enum phía Back-end
  CAReceipt: 'CACashReceipt',

  CAReceiptDetail: 'CAReceiptDetail',
  CAReceiptDetailParallel: 'CAReceiptDetailParallel',
  CAReceiptWithdraw: 'CAReceiptWithdraw',
  CAAdjustReceiptDetail: 'CAAdjustReceiptDetail',
  CAAdjustPaymentDetail: 'CAAdjustPaymentDetail',
  CAFundInventory: 'CAFundInventory',
  BUPlanAdjustment: 'BUPlanAdjustment',
  BUPlanAdjustmentDetail: 'BUPlanAdjustmentDetail',

  // Điều chỉnh kinh phí
  // nvthinh 24.1.2024: Cập nhật theo key enum phía Back-end
  BUPlanWdAdjustment: 'BuPlanWdAdjustment',

  BUPlanWdAdjustmentDetail: 'BUPlanWdAdjustmentDetail',
  BudgetPlanAdjustment: 'BudgetPlanAdjustment',
  BudgetPlanAdjustmentDetail: 'BudgetPlanAdjustmentDetail',
  BUVoucherList: 'BUVoucherList',
  BUVoucherListDetail: 'BUVoucherListDetail',
  BUVoucherListDetailParallel: 'BUVoucherListDetailParallel',
  BADeposit: 'BADeposit',
  BADepositDetail: 'BADepositDetail',
  BADepositDetailParallel: 'BADepositDetailParallel',
  BADepositDetailTax: 'BADepositDetailTax',
  BAAdvanceNSNN: 'BAAdvanceNSNN',

  // Phiếu chi
  // nvthinh 24.1.2024: Cập nhật theo key enum phía Back-end
  CAPayment: 'CACashPayment',

  CAPaymentDetail: 'CAPaymentDetail',
  CAPaymentDetailParallel: 'CAPaymentDetailParallel',
  InInwardOutward: 'InInwardOutward',
  InInwardOutwardDetail: 'InInwardOutwardDetail',
  INTransfer: 'INTransfer', // chuyển kho
  INTransferDetail: 'INTransferDetail',
  InAdjustment: 'InAdjustment',
  InAdjustmentDetail: 'InAdjustmentDetail',

  // Điều chuyển CCDC
  // nvthinh 24.1.2024: Cập nhật theo key enum phía Back-end
  SuTransfer: 'SuTransfer',

  SuTransferDetail: 'SuTransferDetail',
  SuIncrementDecrement: 'SuIncrementDecrement',
  SuIncrementDecrementDetail: 'SuIncrementDecrementDetail',
  FaIncrementDecrement: 'FaIncrementDecrement',
  FaIncrementDecrementDetail: 'FaIncrementDecrementDetail',
  FaDepreciation: 'FaDepreciation',
  FaDepreciationDetail: 'FaDepreciationDetail',
  FaAdjustment: 'FaAdjustment',
  FaAdjustmentDetail: 'FaAdjustmentDetail',
  FaAdjustmentDetailParallel: 'FaAdjustmentDetailParallel',
  PaWorkPoint: 'PaWorkPoint',
  PaWorkPointDetail: 'PaWorkPointDetail',
  PaOtherInputSalary: 'PaOtherInputSalary',
  BUPlanWDAdjustment: 'BUPlanWDAdjustment',
  BUPlanWDAdjustmentDetail: 'BUPlanWDAdjustmentDetail',
  BUTransferDetailPurchase: 'BUTransferDetailPurchase',
  AccountTransfer: 'AccountTransfer',
  SysRefType: 'SysRefType',
  AutoBusiness: 'AutoBusiness',
  BudgetFees: 'BudgetFees',
  Task: 'Task',
  PurchasePurpose: 'PurchasePurpose',
  BABankTransfer: 'BABankTransfer',
  BABankTransferDetail: 'BABankTransferDetail',
  BABankTransferDetailParallel: 'BABankTransferDetailParallel',
  CAPaymentDetailPurchase: 'CAPaymentDetailPurchase',
  SAInvoice: 'SAInvoice',
  SAInvoiceDetail: 'SAInvoiceDetail',
  BAWithdrawDetailPurchase: 'BAWithdrawDetailPurchase',
  BUBudgetReserve: 'BUBudgetReserve',
  BUBudgetReserveDetail: 'BUBudgetReserveDetail',
  AccountingObjectInfo: 'AccountingObjectInfo',
  AccountingObjectCategory: 'AccountingObjectCategory',
  InvoiceFormNumber: 'InvoiceFormNumber',
  VoucherType: 'VoucherType',

  // Đề nghị cam kết chi
  // nvthinh 24.1.2024: Cập nhật theo key enum phía Back-end
  BUCommitmentRequest: 'BuCommitmentRequest',

  BUCommitmentRequestDetail: 'BUCommitmentRequestDetail',

  // Điều chỉnh cam kết chi
  // nvthinh 24.1.2024: Cập nhật theo key enum phía Back-end
  BUPlanAdjustCommit: 'BuPlanAdjustCommit',

  BUPlanAdjustCommitDetail: 'BUPlanAdjustCommitDetail',
  BUOpeningCommitment: 'BUOpeningCommitment',
  BUOpeningCommitmentDetail: 'BUOpeningCommitmentDetail',
  ProjectBudgetDetail: 'ProjectBudgetDetail',
  Contract: 'Contract',
  Topic: 'Topic',
  TopicEstimate: 'TopicEstimate',
  GLVoucherList: 'GLVoucherList',
  GLVoucherListDetail: 'GLVoucherListDetail',
  ProjectExpense: 'ProjectExpense',
  FundStructure: 'FundStructure',
  QltsVoucher: 'QltsVoucher',
  QltsVoucherDetail: 'QltsVoucherDetail',
  QltsVoucherDetailParallel: 'QltsVoucherDetailParallel',
  BATransfer: 'BATransfer',
  BATransferDetail: 'BATransferDetail',
  BATransferDetailParallel: 'BATransferDetailParallel',
  OpeningSupplyEntry: 'OpeningSupplyEntry',
  CRERepList: 'CRERepList',
  FRTemplateCustom: 'FRTemplateCustom',
  CRERepExportList: 'CRERepExportList',
  AccountParallelRule: 'AccountParallelRule',
  AccountParallelRuleDetail: 'AccountParallelRuleDetail',
  DefaultAccount: 'DefaultAccount',
  AutoId: 'AutoId',
  ReportUpdateHistory: 'ReportUpdateHistory',
  OpeningAccountEntry: 'OpeningAccountEntry',
  StateBank: 'StateBank',
  BADepositDetailSale: 'BADepositDetailSale',
  OpeningAccountEntryStatistic: 'OpeningAccountEntryStatistic',
  PayrollItemColumn: 'PayrollItemColumn',
  RegimePosted: 'RegimePosted',
  ImportExcel: 'ImportExcel',
  // tab hệ thống khi mở setting
  OrganizationInfo: 'OrganizationInfo',
  UserManagement: 'UserManagement',
  DataManagement: 'DataManagement',
  RoleManagement: 'RoleManagement',
  AdvancedSercurity: 'AdvancedSercurity',
  AccessHistory: 'AccessHistory',
  DefaultImplicitSetting: 'DefaultImplicitSetting',
  QuickReport: 'QuickReport',
  // tab tiện ích
  CloseBook: 'CloseBook',
  UnCloseBook: 'UnCloseBook',
  PostBatch: 'PostBatch',

  // tab cài đặt chung

  DataMaintaince: 'DataMaintaince',

  // phân hệ hóa đơn
  SASaleInvoice: 'SASaleInvoice',
  Receipt: 'Receipt',
  // RegisterChangeInfo: 'RegisterChangeInfo',
  // CreateTemplate: 'CreateTemplate',
  // CancelInvoice: 'CancelInvoice',

  // Phân hệ kho
  Inventory: 'Inventory', // Phân hệ kho

  // nvthinh 24.1.2024: Cập nhật theo key enum phía Back-end
  InventoryInInward: 'InInward', // Nhập kho
  InventoryInOutward: 'InOutward', // Xuất kho

  InventoryInAjustment: 'InventoryInAjustment', // Điều chỉnh tồn kho
  InventoryInCalculate: 'InventoryInCalculate', // Tính giá xuất kho

  // Phân hệ công cụ dụng cụ
  InventoryItemSuincrement: 'ToolIncrementDecrement', // Ghi tăng CCDC
  InventoryItemSudecrement: 'ToolIncrementDecrement', // Ghi giảm CCDC
  InventoryItemSutransfer: 'InventoryItemSutransfer', // Điều chuyển CCDC

  // Phân hệ lương
  StatisticalDayOff: 'StatisticalDayOff', // Bảng tổng hợp ngày nghỉ, làm thêm, làm đêm
  OtherIncome: 'OtherIncome', // Thu nhập không thường xuyên
  PAOtherOutcome: 'PAOtherOutcome', // Khấu trừ không thường xuyên
  PARetroSalary: 'PARetroSalary', // Truy lĩnh lương
  Salary: 'Salary', // Bảng lương
  GlPayrollExpenseSalaryList: 'SaAccounting', // Hạch toán chi phí lương
  PaySalary: 'PaySalary', // Trả lương
  PayUnionInsurance: 'PayUnionInsurance', // Nộp bảo hiểm, công đoàn phí
  CAPaymentPersonalIncomeTax: 'CAPaymentPersonalIncomeTax', // Tính thuế TNCN
  PAPayTax: 'PAPayTax', // Nộp thuế TNCN
  SaPayment: 'SaPayment', // Chứng từ trả lương, bảo hiểm (author nvthinh 25.1.2024)

  // phân hệ mua hàng
  PUPayment: 'PUPayment', // mua hàng trả tiền ngay
  PuInvoice: 'PuInvoice', // mua hàng chưa thanh toán
  PuInvoiceDetailPurchase: 'PuInvoiceDetailPurchase', // mua hàng chưa thanh toán - chi tiết
  PUVendorPayment: 'PUVendorPayment', // trả tiền nhà cung cấp

  // phân hệ bán hàng
  CAReceiptSale: 'CAReceiptSale', // bán hàng thu tiền ngay
  CAReceiptCustom: 'CAReceiptCustom', // thu tiền khách hàng
  SAInvoice: 'SAInvoice',
  SAInvoiceDetail: 'SAInvoiceDetail',
  SAReturn: 'SAReturn',
  SAReturnDetail: 'SAReturnDetail',

  // TSCĐ
  FAVoucher: 'FAVoucher', // Danh sách TSCĐ
  FAPurchaseIncrement: 'FAPurchaseIncrement', // Ghi tăng tSCĐ
  FATransfer: 'FATransfer', // Điều chuyển tài sản cố định
  FADepreciation: 'FADepreciation', // hao mòn
  FADevaluation: 'FADevaluation', // Trích khấu hao
  FAIncrement: 'FAIncrement', // Nhận bằng hiện vật và ghi tăng TSCĐ
  FaAdjustment: 'FaAdjustment', // Đánh giá lại TSCĐ
  FADecrement: 'FADecrement', // Ghi giảm TSCĐ
  FARevenue: 'FARevenue', // Doanh thu từ bán TSCĐ

  // phân hệ tổng hợp
  SUGeneralVoucher: 'SUGeneralVoucher', // chứng từ nghiệp vụ khác
  SUGeneralVoucherDetail: 'SUGeneralVoucherDetail',

  // nvthinh 24.1.2024: Cập nhật theo key enum phía Back-end
  SUAccountTransfer: 'SUGeneralVoucher', // Phiếu kết chuyển tài khoản
  GLVoucherDetailParallel: 'SUGeneralVoucher', // Chứng từ ghi đồng thời

  SUAccountTransferDetail: 'SUAccountTransferDetail',
  GLVoucherDetailTax: 'GLVoucherDetailTax',
  BeginningYearTransfer: 'BeginningYearTransfer', // quyết toán số dư đầu năm
  GLProfitLossTransfer: 'GLProfitLossTransfer', // Xác định kết quả hoạt dộng
  EndYearTransfer: 'EndYearTransfer', // Kết chuyển số dư cuối năm
  GLPostedVoucher: 'GLPostedVoucher', // Chứng từ ghi sổ
  VoucherSummaryTable: 'VoucherSummaryTable', // Bảng TH chứng từ cùng loại
  CreReport: 'CreReport', // Lập báo cáo
  CrerepexportListTax: 'CrerepexportListTax', // Nộp báo cáo cho cơ quan thuế
  CRERepExportList: 'CRERepExportList', // nộp báo cáo kho bạc
  FrReportConfigList: 'FrReportConfigList', // thiết lập báo cáo tài chính
  BATransferWithDraw: 'BATransferWithDraw', // tiền chuyển đến
  BATransferDeposit: 'BATransferDeposit', // tiền chuyển đi

  // nvthinh 26.1.2024: Cập nhật theo key enum phía Back-end
  BUPlanCancel: 'BuReceipt', // hủy dự toán

  CAReceiptPlanWithdraw: 'CAReceiptPlanWithdraw', // nhập quỹ tiền mặt
  FASaleInvoice: 'FASaleInvoice', // Bán TSCĐ chưa thu tiền
  PuInvoiceDetailFixedAsset: 'PuInvoiceDetailFixedAsset', // Mua TSCĐ chưa thanh toán

  DvcUser: 'DvcUser', // Kho bạc điện tử
  DvcFile: 'DvcFile', // Hồ sơ thanh toán - Kho bạc điện tử
  DvcConnection: 'DvcConnection',
  InitialBalance: 'InitialBalance', // Nhập số dư ban đầu

  // file detail của danh mục
  SystemAccountDetails: 'Account',
  AccountTransferDetail: 'AccountTransfer',
  AutoBusinessDetail: 'AutoBusiness',
  BudgetChapterDetail: 'BudgetChapter',
  BudgetKindItemDetail: 'BudgetKindItem',
  BudgetItemDetail: 'BudgetItem',
  BudgetSourceDetail: 'BudgetSource',
  BudgetSourcePropertyDetail: 'BudgetSourceProperty',
  TargetProgramDetail: 'Project',
  ProjectDetail: 'Project',
  WorkItemDetail: 'Project',
  FundDetail: 'Fund',
  CurrencyDetail: 'Currency',
  BankInfoCategoryDetail: 'TypeOfFundBank',
  BankInfoDetail: 'BankInfo',
  AccountingObjectCategoryDetail: 'AccountingObjectCategory',
  CustomerVendorDetail: 'AccountingObject',
  EmployeeDetail: 'Employee',
  EmployeeTypeDetail: 'EmployeeType',
  PayrollItemDetail: 'PayrollItem',
  SalaryScaleDetail: 'SalaryScale',
  InventoryDetail: 'DicInventory',
  ToolTypeDetail: 'InventoryCategory1',
  ToolDetail: 'InventoryItem',
  InventoryCategoryDetail: 'InventoryCategory',
  InventoryDetail: 'InventoryItem1',
  StockDetail: 'Stock',
  PurchasePurposeDetail: 'PurchasePurpose',
  InvoiceFormNumberDetail: 'InvoiceFormNumber',
  VoucherTypeDetail: 'VoucherType',
  BudgetFeesDetail: 'BudgetFees',
  TaskDetail: 'Task',
  TopicDetail: 'Topic',
  ActivityDetail: 'Activity',
  FundStructureDetail: 'FundStructure',
  StatisticDetail: 'Statistic',
  BudgetGroupItemDetail: 'BudgetGroupItem1',
  ContractDetail: 'Contract',
  BUAppendixList: 'BUAppendixList',
  FARevenue: 'FARevenue',
  QltsVoucher: 'QltsVoucher',
  SubBudgetItem: 'BudgetItemDetail',

  FilterHistory: 'FilterHistory',

  ReportSortInfo: 'ReportSortInfo',

  // Phân hệ thuế
  DeductionTA: 'DeductionTA', // Nghiệp vụ thuế->Khấu trừ thuế
  SubmitTax: 'SubmitTax', // Nghiệp vụ thuế->Nộp thuế
  TACircularVATDeclaration: 'TACircularVATDeclaration', // Nghiệp vụ thuế->Tờ khai thuế

  // Dự toán ngân sách -> Nhận quỹ tiền mặt (Danh sách)
  // nvthinh 24.1.2024: Cập nhật theo key enum phía Back-end
  CACash: 'CACashWithdraw',

  CACashReceipt: 'CACashReceipt',

  // tổng hợp dự toán
  BUPlanSummary: 'BUPlanSummary',

  // biểu tính thuế thu nhập
  // EmployeeIncomeTax: 'EmployeeIncomeTax',
  PAOption: 'PAOption',

  // Biên lai
  EReceipt: 'EReceipt',
  EReceiptVoucher: 'EReceiptVoucher',
  EReceiptSummary: 'EReceiptSummary', // tổng hợp biên lai
  SUCreateReportDetail: 'SUCreateReportDetail',

  // Thiết lập báo cáo cân đối
  BUPlanActivityTempSymmet: 'BUPlanActivityTempSymmet',

  // Kế hoạch vốn đầu tư XDCB
  ConstructionBudget: 'ConstructionBudget',
  ConstructionBudgetDetail: 'ConstructionBudgetDetail',
  // Kế hoạch thu chi các hoạt đông tài chính khác
  BuFinancialActivities: 'BuFinancialActivities',

  // Thiết lập báo cáo thu
  BUPlanTempReceiptReport: 'BUPlanTempReceiptReport',
  // Thiết lập báo cáo chi
  BUPlanTempExpenseReport: 'BUPlanTempExpenseReport',

  // Dự toán ngân sách -> Lập bảng kê
  BUCreateDeclareTable: 'BUCreateDeclareTable',
  // Dự toán ngân sách -> Lập bảng kê -> Lập bảng kê ghi thu ghi chi
  BUReceiptExpense: 'BUReceiptExpense',

  /**
   * Key cho phép thực hiện ghi sổ
   * (Áp dụng đối với các màn không phải chứng từ)
   */
  AllowExecuteBookkeeping: 'AllowExecuteBookkeeping',

  // Hoá đơn mua hàng inbot
  InbotInvoice: 'InbotInvoice',
  DvcBudget: 'DvcBudget',
  VoucherDataRelated: 'VoucherDataRelated',
  DcsdFile: 'DcsdFile', //hồ sơ đối chiếu
  CheckFormulaTT342: 'CheckFormulaTT342', // Kiểm tra công thức biểu 61 62 TT 342

  ExpenseNormRegulation: 'ExpenseNormRegulation',
};
